export const PAYMENT_TO_SPOTAHOME = 'through_spotahome';
export const PAYMENT_TO_LANDLORD = 'to_landlord';
export const PAYMENT_TO_PROVIDER = 'to_provider';

// Frequencies
export const FREQUENCY_MONTHLY = 'monthly';
export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_BI_MONTHLY = 'biMonthly';
export const FREQUENCY_ONE_PAYMENT = 'onePayment';

// Payment methods
export const PAYMENT_METHOD_CASH = 'cash';
export const PAYMENT_METHOD_BANK_TRANSFER = 'bankTransfer';
export const PAYMENT_METHOD_CREDIT_CARD = 'creditCard';
export const PAYMENT_METHOD_PAY_TO_PROVIDER = 'payToProvider';
export const PAYMENT_METHOD_PAY_THROUGH_SPOTAHOME = 'payThroughSpotahome';
export const PAYMENT_METHOD_PAYPAL = 'paypal';

// Cost types
export const COST_TYPE_SAH_FEE = 'spotahomeFee';
export const COST_TYPE_DOWNPAYMENT = 'downpayment';
export const COST_TYPE_MONTHLY_RENT = 'monthlyRent';
export const COST_TYPE_CUSTOM_SERVICE = 'customService';
export const COST_TYPE_CUSTOM_TAX = 'customTax';
export const COST_TYPE_CUSTOM_FEE = 'customFee';

export const COST_CATEGORY_BILLS = 'bills';
export const COST_CATEGORY_MONTHLY_RENT = 'monthlyRent';

export const APPLY_ON_INCLUDED = 'included';
